import React, { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";

const TransferDesignForm = () => {
  const { user, chatData, refreshChatData, validateEcode } = useAuth();
  const [tfDesign, setTfDesign] = useState(chatData?.tf_des || "");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setTfDesign(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    try {
      const response = await fetch("https://kracet.shop/mastapi/tfdesign.php", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          tf_des: tfDesign,
          ecode: user?.ecode,
          chat_id: user?.chat_id,
        }),
      });

      const result = await response.json();

      if (result.success) {
        alert("Transfer Design updated successfully!");
        refreshChatData();
        validateEcode();
      } else {
        alert("Update failed: " + result.message);
      }
    } catch (error) {
      console.error("Error updating Transfer Design:", error);
      alert("An error occurred while updating Transfer Design.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (chatData?.tf_des) {
      setTfDesign(chatData.tf_des);
    }
  }, [chatData]);

  return (
    <form onSubmit={handleSubmit} className="text-center mt-4 mb-6">
      <div>
        <p className="text-lg font-medium">Transfer Design</p>
        <select
          id="transferDesign"
          className="w-3/6 mb-4 p-2 border border-black rounded"
          value={tfDesign}
          onChange={handleChange}
        >
          <option value="sent">sent</option>
          <option value="claimed">claimed</option>
        </select>
      </div>
      <div>
        <button
          type="submit"
          className="bg-teal-700 px-4 py-2 rounded-lg text-white flex items-center justify-center mx-auto"
          disabled={isLoading}
        >
          {isLoading ? (
            <svg
              className="animate-spin h-5 w-5 mr-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8z"
              ></path>
            </svg>
          ) : null}
          {isLoading ? "Updating..." : "Update"}
        </button>
      </div>
    </form>
  );
};

export default TransferDesignForm;
